import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { makeRequest, METHODS } from './baseRequest.js';
import settings from '../settings.js';
import { buildUrl } from '../utils/buildUrl.js';
import { memoizeAsync } from '../utils/memoize.js';

function fetchUserInfo() {
    return __awaiter(this, void 0, void 0, function* () {
        let url = buildUrl(settings.userInfoUrl, {
            language: settings.language,
            backendUrl: settings.backendUrl,
        });
        if (settings.showDevPanel && settings.country) {
            url = `${url}?country=${settings.country}`;
        }
        return makeRequest(METHODS.GET, url);
    });
}
const getUserInfo = memoizeAsync(fetchUserInfo.name, fetchUserInfo);

export { fetchUserInfo, getUserInfo };
//# sourceMappingURL=user.js.map
